module.exports = __webpack_public_path__ + "img/WeThrive-logo-black.025a87aa.png";